export default __webpack_public_path__ + "static/media/episode_comment.98da3b97.png";